import React, {MouseEventHandler} from "react";

interface IconProps {
    icon: string;
    className?: string;
    hexColor?: string,
    clickable?: boolean,
    onClick?: MouseEventHandler<HTMLSpanElement> | undefined;
}

export const Icon = React.forwardRef(({icon, className, onClick, hexColor, clickable, ...passedProps}: IconProps, ref: React.ForwardedRef<HTMLSpanElement>): JSX.Element => {
    const mergedClasses = [
        className,
        (onClick || clickable) && "cursor-pointer",
        "material-symbols-outlined select-none"
    ].filter(Boolean).join(" ");

    return (
        <span ref={ref} onClick={onClick} translate="no" className={mergedClasses} style={{color: `${hexColor}`,}} {...passedProps} dangerouslySetInnerHTML={{__html: icon}}/>
    );
});

